import {
    WORKPLAND_FAILED,
    WORKPLAND_FETCHING,
    WORKPLAND_SUCCESS,
} from "../../Constants.ts";

export interface WorkPlanState {
    isFetching: boolean;
    isError: boolean;
    result: any;
}

const initialState: WorkPlanState = {
    isFetching: false,
    isError: false,
    result: null,
};

export default (state = initialState, { type, payload }: any): WorkPlanState => {
    switch (type) {
        case WORKPLAND_FETCHING:
            return { ...state, isFetching: true, isError: false, result: null };
        case WORKPLAND_SUCCESS:
            return { ...state, isFetching: false, isError: false, result: payload };
        case WORKPLAND_FAILED:
            return { ...state, isFetching: false, isError: true, result: null };
        default:
            return state;
    }
};
